import React from "react";
import {
  List,
  Edit,
  Create,
  Datagrid,
  TextField,
  EditButton,
  EmailField,
  SimpleForm,
  TextInput,
  ReferenceInput,
  ReferenceField,
  SelectInput,
  Show,
  ShowButton,
  SimpleShowLayout,
  ReferenceArrayInput,
  SelectArrayInput,
  FormDataConsumer,
  required,
  Pagination,
  email as validateEmail,
} from "react-admin";

import { isRestrictedKioskUser } from "../lib/permissions";

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100, 200]} {...props} />
);

export const UserList = ({ permissions, ...props }) => (
  <List
    title="Utilisateurs"
    perPage={25}
    pagination={<PostPagination />}
    {...props}
  >
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" label="Nom" />
      <TextField source="username" label="Identifiant" />
      <EmailField source="email" />
      {permissions === "super_admin" && (
        <ReferenceField
          label="Station"
          source="stationid"
          reference="stations"
          linkType="show"
        >
          <TextField source="location" />
        </ReferenceField>
      )}
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);

const UserTitle = ({ record }) => (
  <span>Utilisateur {record ? record.username : ""}</span>
);

export const UserForm = ({ permissions, isCreate = false }) => (
  <SimpleForm>
    <TextInput source="name" label="Nom" validate={required()} />
    <TextInput source="username" label="Identifiant" validate={required()} />
    <TextInput source="email" type="email" validate={validateEmail()} />
    <TextInput source="phone" label="Téléphone" validate={required()} />
    <TextInput
      source="password"
      type="password"
      label="Mot de passe"
      validate={isCreate ? required() : null}
    />
    <SelectInput
      label="Role"
      source="roles"
      validate={required()}
      choices={[
        { id: "station_admin", name: "Station admin" },
        { id: "station_user", name: "Station user" },
        { id: "station_viewer", name: "Station viewer" },
      ]}
    />
    <FormDataConsumer>
      {({ formData, ...rest }) =>
        isRestrictedKioskUser(formData.roles) && (
          <ReferenceArrayInput
            label="Bornes"
            source="kiosks"
            reference="kiosks"
            {...rest}
          >
            <SelectArrayInput optionText="title" />
          </ReferenceArrayInput>
        )
      }
    </FormDataConsumer>
    {permissions === "super_admin" && (
      <ReferenceInput label="Station" source="stationid" reference="stations">
        <SelectInput optionText="location" />
      </ReferenceInput>
    )}
  </SimpleForm>
);

export const UserEdit = ({ permissions, ...props }) => (
  <Edit title={<UserTitle />} {...props}>
    {UserForm({ permissions })}
  </Edit>
);

export const UserCreate = ({ permissions, ...props }) => (
  <Create title="Créer un utilisateur" {...props}>
    {UserForm({ permissions, isCreate: true })}
  </Create>
);

export const UserShow = ({ permissions, ...props }) => (
  <Show title={<UserTitle />} {...props}>
    <SimpleShowLayout>
      <TextField source="name" label="Nom" />
      <TextField source="username" label="Identifiant" />
      <TextField source="email" type="email" />
      <TextField source="phone" label="Téléphone" />
      <TextField source="roles" label="Role" />
      {permissions === "super_admin" && (
        <ReferenceField label="Station" source="stationid" reference="stations">
          <TextField source="location" />
        </ReferenceField>
      )}
    </SimpleShowLayout>
  </Show>
);



// WEBPACK FOOTER //
// ./src/components/users.js